<template>
  <div
    class="mobile_vote"
    v-loading.fullscreen.lock="voteLoading"
    :element-loading-text="this.$config.loadingText"
    :element-loading-spinner="this.$config.loadingSpinner"
    :element-loading-background="this.$config.loadingBackground"
  >
    <div class="mobile_vote_head">
      <div class="mobile_head_left">
        <a @click="goBack()">
          <i class="el-icon-arrow-left"></i>
        </a>
      </div>
      <span class="mobile_head_desc"> {{ voteInfo.VoteName }} </span>
      <div class="mobile_head_right">
        <a @click="refreshList()">
          <i class="el-icon-refresh"></i>
        </a>
      </div>
    </div>
    <div class="mobile_chair_body" :style="bodyStyle">
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item
          class="mobile_chair_item_box"
          v-for="(item, index) in voteGroupProjects"
          :key="index"
          :name="item.Id"
        >
          <template slot="title">
            <div class="mobile_chair_item_head">
              {{ '（' + item.Number + '）' + item.Name }}
            </div>
          </template>
          <div class="mobile_chair_group_award">
            <el-button @click="openAwardCeremony(item)" size="mini" plain>
              <i class="iconfont icon-banjiangdianli"></i>
              颁奖典礼
            </el-button>
          </div>
          <div
            class="mobile_chair_item_body"
            v-for="(project, projectIndex) in item.ChairScreenVoteProjects"
            :key="projectIndex"
          >
            <div>{{ project.Number }}）{{ project.ProjectName }}</div>
            <div>
              <el-button
                type="primary"
                class="open_project_btn"
                @click="openProject(item, project)"
                plain
              >
                进入项目
              </el-button>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="mobile_vote_foot">
      <el-link @click="goBack()">返回投票列表</el-link>

      <el-popover
        placement="bottom"
        width="350"
        trigger="click"
        v-model="switchVoteVisible"
        @show="getShortlistedScreenVoteList()"
      >
        <el-table :data="screenVoteItems" v-loading="switchVoteLoading">
          <el-table-column header-align="right">
            <template slot="header">
              <el-link
                title="关闭"
                icon="el-icon-close"
                :underline="false"
                @click="switchVoteVisible = false"
              ></el-link>
            </template>
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="openShortlistedScreenVote(scope.row)"
              >
                {{ scope.row.VoteName }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-link slot="reference"> 切换投票 </el-link>
      </el-popover>
    </div>
  </div>
</template>

<script>
import screenApi from '../../../api/mobileVote/screen'
import voteApi from '../../../api/mobileVote/vote'
export default {
  data () {
    return {
      activeNames: [],
      voteLoading: false,
      voteGroupProjects: [],
      voteInfo: {},
      bodyStyle: {
        marginTop: '45px'
      },
      screenVoteItems: [],
      switchVoteLoading: false,
      switchVoteVisible: false
    }
  },
  methods: {
    getScreenVoteGroupProjects: function () {
      this.voteLoading = true
      screenApi.getScreenVoteGroupProjects({
        voteId: this.$route.params.vid
      }).then(data => {
        this.voteGroupProjects = data
        // if (this.voteGroupProjects.length > 0) {
        //   this.activeNames.push(this.voteGroupProjects[0].Id)
        // }
        this.activeNames = []
        if (this.voteGroupProjects.length > 0) {
          this.voteGroupProjects.forEach(item => {
            this.activeNames.push(item.Id)
          })
        }
        this.voteLoading = false
      }).catch(err => {
        this.voteLoading = false
        return err
      })
    },
    getScreenVoteSponsorInfo: function () {
      screenApi.getScreenVoteSponsorInfo({
        voteId: this.$route.params.vid
      }).then(data => {
        this.voteInfo = data
      }).catch(err => {
        return err
      })
    },
    refreshList: function () {
      this.getScreenVoteGroupProjects()
    },
    goBack: function () {
      this.$router.push({ name: 'voteList', params: { mid: this.$route.params.mid } })
    },
    handleChange (val) {

    },
    openProject: function (group, project) {
      this.voteLoading = true
      screenApi.chairScreenVoteOpenProject({
        meetingId: this.$route.params.mid,
        voteId: this.$route.params.vid,
        groupId: group.Id,
        projectId: project.ProjectID
      }).then(data => {
        this.$router.push({ name: 'chairScreenControl', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, gid: group.Id, pid: project.ProjectID } })
        this.voteLoading = false
      }).catch(err => {
        this.voteLoading = false
        return err
      })
    },
    openAwardCeremony: function (group) {
      const _this = this
      _this.$router.push({ name: 'chairAwardCeremonyList', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid } })
      //   this.voteLoading = true
      //   screenApi.chairScreenVoteAwardCeremony({
      //     meetingId: this.$route.params.mid,
      //     voteId: this.$route.params.vid,
      //     groupId: group.Id
      //   }).then(data => {
      //     this.voteLoading = false
      //   }).catch(err => {
      //     this.voteLoading = false
      //     return err
      //   })
    },
    getShortlistedScreenVoteList: function () {
      this.switchVoteLoading = true
      voteApi.getShortlistedScreenVoteList({
        meetingID: this.$route.params.mid
      }).then(data => {
        this.screenVoteItems = data
        this.switchVoteLoading = false
      }).catch(err => {
        this.switchVoteLoading = false
        return err
      })
    },
    openShortlistedScreenVote: function (toVote) {
      const _this = this
      _this.openLoading()
      voteApi.openShortlistedScreenVote({
        FromVoteId: _this.$route.params.vid,
        ToVoteId: toVote.VoteId,
        ToVoteType: toVote.VoteType,
        MeetingId: _this.$route.params.mid
      }).then(data => {
        _this.openLoading().close()
        if (toVote.VoteType === 0) {
          _this.$router.push({ name: 'chairShortlistedScreen', params: { mid: _this.$route.params.mid, vid: toVote.VoteId } })
        }
        if (toVote.VoteType === 3) {
          _this.$router.push({ name: 'chairScreenProjects', params: { mid: _this.$route.params.mid, vid: toVote.VoteId } })
        }
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    }
  },
  mounted () {
    this.getScreenVoteGroupProjects()
    this.getScreenVoteSponsorInfo()
  }
}
</script>

<style lang="less">
@import '../../../assets/css/mobileVote/vote.css';
.mobile_chair_item_box .el-collapse-item__header {
  //   height: auto;
  //   line-height: 24px;
  background-color: #f5f7fa;
}
</style>
